import { render, staticRenderFns } from "./TreatmentRecord.vue?vue&type=template&id=6412f71f&scoped=true&"
import script from "./TreatmentRecord.vue?vue&type=script&lang=js&"
export * from "./TreatmentRecord.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentRecord.vue?vue&type=style&index=0&id=6412f71f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6412f71f",
  null
  
)

export default component.exports